import { GET_ORGANIZATIONS_ACTIONS } from './constants';

export const getOrganizations = () => ({
  type: GET_ORGANIZATIONS_ACTIONS.START,
});

export const getOrganizationsFail = (error: any) => ({
  type: GET_ORGANIZATIONS_ACTIONS.FAIL,
  error,
});

export const getOrganizationsSuccess = (data: any) => ({
  type: GET_ORGANIZATIONS_ACTIONS.SUCCESS,
  data,
});

export const getOrganizationsReset = () => ({
  type: GET_ORGANIZATIONS_ACTIONS.RESET,
});
